// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import Modal from 'react-responsive-modal'
import Button from '../../controls/PrimaryButton'
import type { VkEventGroup, OptionType, VkEventSources } from '../../types'
import VkEventForm from './VkEventForm'
import VkEventGroupsList from './VkEventGroupsList'
import ErrorText from '../../controls/ErrorText'

const StyledLabel: StyledComponent<Object, any, any> = styled.h2`
  margin: 10px 0 10px 0;
`

type Props = {|
  vkEventSources: VkEventSources,
  vkEventGroups: Array<VkEventGroup>,
  vkEventOptions: Array<OptionType>,
  errors: Array<string>,
  onChange: Function,
  onClick: Function
|}

type State = {|
  isOpen: boolean
|}

const t = {
  label: 'Сбор реакций ВКонтакте',
  setup: 'Настроить'
}

export default class VkEventGroups extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      isOpen: false
    }
  }

  render() {
    const { vkEventSources, vkEventGroups, vkEventOptions, errors, onChange } = this.props
    const { isOpen } = this.state

    return (
      <div>
        <Modal open={isOpen} onClose={() => this.setState({ isOpen: false })}>
          <VkEventForm
            vkEventSources={vkEventSources}
            vkEventGroups={vkEventGroups}
            vkEventOptions={vkEventOptions}
            onChange={(diff) => onChange(diff)}
            onClose={() => this.setState({ isOpen: false })}
          />
        </Modal>
        <StyledLabel>{t.label}</StyledLabel>
        {!_.isEmpty(vkEventGroups) && (
          <VkEventGroupsList
            vkEventGroups={vkEventGroups}
            vkEventOptions={vkEventOptions}
            onClick={(eventGroup) => this.props.onClick(eventGroup, vkEventGroups)}
          />
        )}
        <ErrorText errors={errors} />
        <div>
          <Button
            small
            onClick={(event) => {
              event.preventDefault()
              this.setState({ isOpen: true })
            }}
          >
            {t.setup}
          </Button>
        </div>
      </div>
    )
  }
}
